//@ts-nocheck
import { useEffect, useState } from 'react';
import { Button, Paper, InputBase, IconButton, Tabs, Tab, Menu, MenuItem, FormControlLabel, Checkbox } from '@mui/material';
import { IconExport, IconSearch, ReportIcon } from '../../../icons/Icon';
import ListData from './ListData';
import styles from './ProductionPlanDetails.module.scss';
import CustomTabPanel from '../../../components/commonComponent/CustomTabPanel';
import { useSelector } from 'react-redux';
import { fetchProductionPlan, fetchProductionPlanReport, setProductionPlanParams } from '../../../services/productionPlanSlice';
import { ThunkDispatch } from '@reduxjs/toolkit';
import { useDispatch } from 'react-redux';
import Loader from '../../../components/loader/Loader';
import { useNavigate } from 'react-router-dom';
import * as XLSX from 'xlsx-js-style';
import { format } from 'date-fns';
import { toast } from 'react-toastify';
import axiosInstance from '../../../api/axios';
import { BASE_URL } from '../../../constants/apiConstants';
import { headerStyle, contentStyle, sectionStyle, daypartStyle, titleStyle, dishStyle } from '../../../utils/constants';

const ProductionPlanDetails = () => {
  const dispatch: ThunkDispatch<any, any, any> = useDispatch();
  const navigate = useNavigate();
  const [openIndices, setOpenIndices] = useState<number[]>([0]);
  const [value, setValue] = useState(0);
  const [searchTerm, setSearchTerm] = useState<string>("");
  const userId = localStorage.getItem('userid');
  const roleId = JSON.parse(localStorage.getItem('roleId') || "");
  const { params, previousPlan, productionData, reportData, loading, dayparts, sites } = useSelector((state: any) => state.productionPlan);
  const mealTimeOptions = dayparts?.length ? dayparts?.map((daypart: any) => { return { label: daypart?.name, value: daypart?.id, id: daypart?.id, code: daypart?.id } }) : [];
  const dynamicMealTimeOptions = [{ label: 'All Mealtime', value: 'All', id: 0, code: 'ALL' }, ...mealTimeOptions];
  const disableCTA = productionData[0]?.daypartdishlist?.length ? false : true;
  const showUpdatePlan: boolean = previousPlan ? roleId == 1 ? true : !previousPlan : !previousPlan;
  const [selectedOptions, setSelectedOptions] = useState<string[]>([]);
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [userData, setUserData] = useState<any>();  
  const userInfo = JSON.parse(localStorage.getItem('userInfo') || '{}');
  const userIsItem = userInfo?.userdetails?.isitemwise;  
 
  // Toggle individual accordion sections
  const handleToggle = (index: number) => {
    setOpenIndices(prevIndices =>
      prevIndices.includes(index) ? prevIndices.filter(i => i !== index) : [index]
    );
  };

  useEffect(() => {
    const userInfo = JSON.parse(localStorage.getItem('userInfo') || '{}');
    if (userInfo) {
      const type = userInfo?.userdetails;
      setUserData(type);
    }
  }, []);

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };
  // Expand all sections
  const handleExpandAll = () => {
    setOpenIndices(productionData[value]?.daypartdishlist?.map((__: any, index: number) => index));
  };

  // Collapse all sections
  const handleCollapseAll = () => {
    setOpenIndices([]); // 
  };

  const handleMenuOpen = (event: any) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleOptionChange = (event: any) => {
    const value = event?.target?.name;
    if (value === "All" && !selectedOptions.includes('All')) {
      setSelectedOptions(dynamicMealTimeOptions?.map(e => e?.value))
    } else if (value === "All" && selectedOptions.includes('All')) {
      setSelectedOptions([])
    } else {
      setSelectedOptions((prev: any) =>
        prev.includes(value)
          ? prev.filter((option: any) => option !== value)
          : [...prev, value]
      );
    }
  };

  const handleSubmit = () => {
    const filterParams = {
      ...params,
      indentdayparts: selectedOptions.filter(option => option != "All"),
    }
    dispatch(setProductionPlanParams(filterParams));
    setAnchorEl(null);
    navigate('/kitchenindent')
  };

  useEffect(() => {    
    const payload = {
      userid: userId,
      IsItemWise:userInfo?.userdetails?.isitemwise,
      ...params
    }
    dispatch(fetchProductionPlan(payload));
  }, [params]);


  const getRemarks = (dish: any) => {
    if (!dish || !Array.isArray(dish.remarks)) return "";
    const weightPerPcSum: Record<number, { quantity: number; uom: string; sites: string[] }> = {};
    const siteRemarks: string[] = [];
    for (const site of dish.remarks) {
      // if (!site.portionverientlist?.length || site.portionverientlist[0].portionuom !== "Pcs") {
      if (!site.portionverientlist?.length) {
        continue;
      }

      if (site.remark && site.remark.some((r: string) => r.trim().length > 0)) {
        const remarks = site.remark.filter((r: string) => r.trim().length > 0).join(", ");
        siteRemarks.push(`${site.sitename}- ${site.sitecode}: ${remarks}`);
      }
      for (const portion of site.portionverientlist) {
        const { weightperpc, quantity, portionuom } = portion;
        if (portionuom === "Pcs") {
          const siteInfo = `${site.sitename} - ${site.sitecode}`;
          if (weightPerPcSum[weightperpc]) {
            weightPerPcSum[weightperpc].quantity += quantity;
            if (!weightPerPcSum[weightperpc].sites.includes(siteInfo)) {
              weightPerPcSum[weightperpc].sites.push(siteInfo);
            }
          } else {
            weightPerPcSum[weightperpc] = { quantity, uom: portionuom, sites: [siteInfo] };
          }
        }
      }
    }
    // if (Object.keys(weightPerPcSum).length === 0) return siteRemarks.join(", ");
    const weightString = Object.entries(weightPerPcSum)
      .map(([weight, data]) => `${data.quantity}-${weight}/${data.uom} [${data.sites.join(", ")}]`)
      .join(", ");

    const siteRemarkString = siteRemarks.length > 0 ? `${weightString && ', '}${siteRemarks.join(", ")}` : "";
    return weightString + siteRemarkString;
  };
 // Helper function to calculate optimal column widths based on content
  const calculateColumnWidths = (data: any[][]) => {
    const columnWidths: number[] = [];
    
    data.forEach((row) => {
      row.forEach((cell, colIndex) => {
        const cellValue = String(cell || '');
        const cellLength = cellValue.length;
        // Calculate width: minimum 10 characters, add padding
        const calculatedWidth = Math.max(10, Math.min(cellLength + 2, 100));
        
        if (!columnWidths[colIndex] || columnWidths[colIndex] < calculatedWidth) {
          columnWidths[colIndex] = calculatedWidth;
        }
      });
    });
    
    return columnWidths.map(width => ({ wch: width }));
  };
 const getSiteWiseRemark = (siteData: any[]) => {
    const weightPerPcSum: Record<number, { quantity: number; uom: string; sites: string[] }> = {};
    const siteRemarks: string[] = [];

    for (const site of siteData) {
      // if (!site.portionverientlist?.length || site.portionverientlist[0].portionuom !== "Pcs") {
      if (!site.portionverientlist?.length) {
        continue;
      }
      if (site.remark && site.remark.some((r: string) => r.trim().length > 0)) {
        const remarks = site.remark.filter((r: string) => r.trim().length > 0).join(", ");
        siteRemarks.push(`${site.sitename}- ${site.sitecode}: ${remarks}`);
      }
      for (const portion of site.portionverientlist) {
        const { weightperpc, quantity, portionuom } = portion;
        if (portionuom === "Pcs") {
          const siteInfo = `${site.sitename} - ${site.sitecode}`;
          if (weightPerPcSum[weightperpc]) {
            weightPerPcSum[weightperpc].quantity += quantity;
            if (!weightPerPcSum[weightperpc].sites.includes(siteInfo)) {
              weightPerPcSum[weightperpc].sites.push(siteInfo);
            }
          } else {
            weightPerPcSum[weightperpc] = { quantity, uom: portionuom, sites: [siteInfo] };
          }
        }
      }
    }
    const weightString = Object.entries(weightPerPcSum)
      .map(([weight, data]) => `${data.quantity}-${weight}/${data.uom} [${data.sites.join(", ")}]`)
      .join(", ");

    const siteRemarkString = siteRemarks.length > 0 ? siteRemarks.join(", ") : "";
    const finalRemark = [weightString, siteRemarkString].filter(Boolean).join(" , ");
    return finalRemark ? finalRemark : "";
  };
 const getExcelData = (daypartdishlist: any, rowIndexes: any, startingIndex: any) => {
    const columnHeaders = [["Dish", "Diet Category", "Total Quantity", "UOM", "Produced Quantity", "Dispatch Quantity", "Temperature", "Remarks"]]
    let excelData = [
      ...columnHeaders
    ]
    startingIndex++;
    rowIndexes.push({
      index: startingIndex,
      style: 'header'
    })
    daypartdishlist?.forEach((daypart: any) => {
      if (daypart?.disheslist && daypart?.disheslist?.length > 0) {
        const daypartRow = [[`${daypart?.name}`, ...Array(7).fill('')]]
        excelData = [
          ...excelData,
          ...daypartRow
        ]
        startingIndex++;
        rowIndexes.push({
          index: startingIndex,
          style: 'daypart'
        })
        daypart?.disheslist?.forEach((dish: any) => {
          const remarks = getRemarks(dish)
          const dishesRow = [[dish?.name, dish?.dietcategory, dish?.totalqty, dish?.uom, "", "", "", remarks?.length > 0 ? remarks : ""]]
          excelData = [
            ...excelData,
            ...dishesRow
          ]
          startingIndex++;
          rowIndexes.push({
            index: startingIndex,
            style: dish?.name?.includes('Event') ? 'dish' : 'content'
          })
        })
      }
      excelData = [
        ...excelData,
        ...[[]]
      ]
      startingIndex++;
    })
    return excelData;
  }


   function getCafeWiseQty(dish, sites, type) {
    const siteData = dish?.sites
    const result = [];
    sites.forEach(site => {
      const siteInfo = siteData.find(data => data.sitecode === site.sitecode);
      site.cafelist.forEach(cafe => {
        // Check if the cafe exists in the siteData
        if (siteInfo && siteInfo.cafes) {
          const cafeInfo = siteInfo.cafes.find(c => c.cafecode === cafe.cafecode);
          // If cafe exists, push the pax value, otherwise push an empty string
          if (type === 'cafewise') {
            result.push(cafeInfo ? Number(cafeInfo.pax) : " ");
            result.push(cafeInfo ? Number(cafeInfo.qty) : " ");
          } else {
            result.push(cafeInfo ? Number(cafeInfo.qty) : " ");
          }
        } else {
          // If siteInfo or cafes is not found, push an empty string
          if (type === 'cafewise') {
            result.push(" ", " ");
          } else {
            result.push(" ");
          }
        }
      });
    });

    return result;
  }
    const getReportData = (section: any, rowIndex: any, mergedCellRows: any, type: string, rowIndexes, startingIndex) => {
    const sitesHeader = section?.sitelist?.flatMap(site => [site.sitename, ...Array(site?.cafelist?.length - 1).fill('')]);
    const cafesHeader = section?.sitelist?.flatMap(site => site.cafelist.map(cafe => cafe?.cafename));
    let excelData = []
    let maxWidth = 0
    let siteMerges = []; // Track site header merges
    
    if (type === 'cafewise') {
      const siteswiseHeader = section?.sitelist?.flatMap(site => [site.sitename, ...Array(2 * (site?.cafelist?.length) - 1).fill('')]);
      
      // Track merges for site headers in cafewise
      let colOffset = 4; // Start after "Dish", "Diet Category", "Total Quantity", "UOM"
      section?.sitelist?.forEach((site: any) => {
        const cafeCount = site?.cafelist?.length || 0;
        const spanColumns = 2 * cafeCount; // Each cafe has Pax and Qty columns
        if (cafeCount > 1) {
          siteMerges.push({ s: { r: startingIndex + 1, c: colOffset }, e: { r: startingIndex + 1, c: colOffset + spanColumns - 1 } });
        }
        colOffset += spanColumns;
      });
      
      const columnSubheader = [["", "", "", "", ...cafesHeader?.flatMap(item => [item, ' ']).flat(), "", "", "", ""]]
      const columnPaxQtyheader = [["", "", "", "", ...Array.from({ length: cafesHeader?.length }, () => ["Pax", "Qty"]).flat(), "", "", "", ""]]
      const columnHeaders = [["Dish", "Diet Category", "Total Quantity", "UOM", ...siteswiseHeader?.flat(), "Produced Quantity", "Dispatch Quantity", "Temperature", "Remarks"]]
      maxWidth = columnHeaders[0]?.length
      startingIndex++;
      rowIndexes.push({
        index: startingIndex,
        style: 'header'
      })
      rowIndexes.push({
        index: startingIndex + 1,
        style: 'header'
      })
      rowIndexes.push({
        index: startingIndex + 2,
        style: 'header'
      })
      excelData = [
        ...columnHeaders,
        ...columnSubheader,
        ...columnPaxQtyheader,
        ...[[]]
      ]
      startingIndex += 3;
      rowIndex += 4;
    } else {
      // Track merges for site headers in dispatch
      let colOffset = 4; // Start after "Dish", "Diet Category", "Total Quantity", "UOM"
      section?.sitelist?.forEach((site: any) => {
        const cafeCount = site?.cafelist?.length || 0;
        if (cafeCount > 1) {
          siteMerges.push({ s: { r: startingIndex + 1, c: colOffset }, e: { r: startingIndex + 1, c: colOffset + cafeCount - 1 } });
        }
        colOffset += cafeCount;
      });
      
      const columnSubheader = [["", "", "", "", ...cafesHeader?.flat(), "", "", "", ""]]
      const columnHeaders = [["Dish", "Diet Category", "Total Quantity", "UOM", ...sitesHeader?.flat(), "Produced Quantity", "Dispatch Quantity", "Temperature", "Remarks"]]
      maxWidth = columnHeaders[0]?.length
      startingIndex++;
      rowIndexes.push({
        index: startingIndex,
        style: 'header'
      })
      rowIndexes.push({
        index: startingIndex + 1,
        style: 'header'
      })
      excelData = [
        ...columnHeaders,
        ...columnSubheader,
        ...[[]]
      ]
      startingIndex += 2;
      rowIndex += 3;
    }
    section?.daypartdishlist?.forEach((daypart: any) => {
      if (daypart?.categorieslist && daypart?.categorieslist?.length > 0) {
        excelData = [
          ...excelData,
          ...[[`${daypart?.name}`, ...Array(maxWidth - 1).fill('')]]
        ]
        rowIndex++;
        startingIndex++;
        rowIndexes.push({
          index: startingIndex,
          style: 'daypart'
        })
        daypart?.categorieslist.forEach((cat: any) => {
          if (cat?.dishcategoryname) {
            excelData = [
              ...excelData,
              ...[[`${cat?.dishcategoryname}`, ...Array(maxWidth - 1).fill('')]]
            ]
            rowIndex++;
            startingIndex++;
            rowIndexes.push({
              index: startingIndex,
              style: 'content'
            })
          }
          cat?.disheslist?.map((dish: any) => {
            if (type === 'cafewise') {
              const remark = getSiteWiseRemark(dish?.sites)
              const dishesRow = [[dish?.name, dish?.dietcategory, dish?.totalqty, dish?.uom, ...getCafeWiseQty(dish, section?.sitelist, type).flat(), "", "", "", remark]]
              excelData = [
                ...excelData,
                ...dishesRow
              ]
            } else {
              const remark = getSiteWiseRemark(dish?.sites)
              const dishesRow = [[dish?.name, dish?.dietcategory, dish?.totalqty, dish?.uom, ...getCafeWiseQty(dish, section?.sitelist, type).flat(), "", "", "", remark]]
              excelData = [
                ...excelData,
                ...dishesRow
              ]
            }
            rowIndex++;
            startingIndex++;

            if (dish.name.includes('Event')) {
              rowIndexes.push({
                index: rowIndex,
                style: 'dish'
              })
            }

          })
        })
      }
      excelData = [
        ...excelData,
        ...[[]]
      ]
      rowIndex++;
      startingIndex++;
    })
    return { excelData, siteMerges };
  }

  const handleExport = () => {
    const workbook = XLSX.utils.book_new();
    if (productionData.length > 0) {
      productionData.map((section: any) => {
        let startingIndex = 0;
        let rowIndexes = [{
          index: startingIndex,
          style: 'title'
        }]
      
        const exportSiteName = userData?.cpusitename || sites?.[0]?.sitename || '';
        const exportSiteCode = (userData?.cpusitecode && userData?.cpusitecode !== "0")
          ? userData?.cpusitecode
          : (sites?.[0]?.sitecode || '');
        const headerText = `Production Plan - ${exportSiteName}-${exportSiteCode}`; 
       const header = [[headerText, ...Array(7).fill('')]]
        const dateHeader = [[params ? format(new Date(params.menudate), 'dd MMM yyyy') : 'No Date']]
        let exportData: any = [
          ...header,
          ...dateHeader,
          ...[['']],
        ];
        startingIndex += 3;
        const sectionHeader = [[`${section?.kitchensectionname}`, ...Array(7).fill('')]]
        rowIndexes.push({
          index: startingIndex,
          style: 'section'
        })       
        const combinedData = getExcelData(section?.daypartdishlist, rowIndexes, startingIndex)        
        exportData = [
          ...exportData,
          ...sectionHeader,
          ...combinedData,
          ...[['']]
        ]
     

        // Determine actual max columns and expand header and date row to match
        const maxWidth = Math.max(...exportData.map((r: any[]) => (r ? r.length : 0)), 1);
        exportData[0] = [headerText, ...Array(Math.max(0, maxWidth - 1)).fill('')];
        exportData[1] = [params ? format(new Date(params.menudate), 'dd MMM yyyy') : 'No Date', ...Array(Math.max(0, maxWidth - 1)).fill('')];

        // Create worksheet after exportData has correct column counts
        const worksheet = XLSX.utils.aoa_to_sheet(exportData);
        worksheet['!cols'] = calculateColumnWidths(exportData);
        //worksheet['!cols'] = Array(maxWidth).fill(null).map(() => ({ wch: 15 }));
        // Merge title and date rows across all columns
        worksheet["!merges"] = [
          { s: { r: 0, c: 0 }, e: { r: 0, c: Math.max(0, maxWidth - 1) } }, // Merge header across all columns
          { s: { r: 1, c: 0 }, e: { r: 1, c: Math.max(0, maxWidth - 1) } }, // Merge date row across all columns
        ];

        // Apply full border only to the date row (row index 1) across all columns
        for (let c = 0; c < maxWidth; c++) {
          const addr = XLSX.utils.encode_cell({ r: 1, c });
          if (!worksheet[addr]) worksheet[addr] = { v: '' };
          if (!worksheet[addr].s) worksheet[addr].s = {};
          const existingStyle = { ...worksheet[addr].s };
          worksheet[addr].s = {
            ...existingStyle,
            border: {
              top: { style: 'thin', color: { rgb: '000000' } },
              bottom: { style: 'thin', color: { rgb: '000000' } },
              left: { style: 'thin', color: { rgb: '000000' } },
              right: { style: 'thin', color: { rgb: '000000' } }
            }
          };
        }
        
        rowIndexes?.forEach((rowIndex => {
          // Prepare local header/content styles for handleExport only (header bold, content not bold)
          const localHeaderStyle = { ...headerStyle, font: { ...((headerStyle && headerStyle.font) || {}), bold: true } };
          const localHeaderCenter = { ...localHeaderStyle, alignment: { horizontal: 'center', vertical: 'center' } };
          // content style for value cells WITHOUT fill so row backgrounds aren't applied
          const localContentStyle = { ...contentStyle, font: { ...((contentStyle && contentStyle.font) || {}), bold: false } };
          if (localContentStyle && localContentStyle.fill) delete localContentStyle.fill;
          const localContentCenter = { ...localContentStyle, alignment: { horizontal: 'center', vertical: 'center' } };

          // Apply the header/style to all header cells
          for (let colIndex = 0; colIndex < maxWidth; colIndex++) {
            const cellAddress = XLSX.utils.encode_cell({ r: rowIndex?.index, c: colIndex });
            if (!worksheet[cellAddress]) {
              worksheet[cellAddress] = {};
            }
              switch (rowIndex?.style) {
              case 'title':
                worksheet[cellAddress].s = titleStyle;
                break;
              case 'header':
                // Center align only these specific header columns (indices 1..6)
                if (colIndex >= 1 && colIndex <= 6) {
                  worksheet[cellAddress].s = localHeaderCenter;
                } else {
                  worksheet[cellAddress].s = localHeaderStyle;
                }
                break;
              case 'section':
                // If this section row contains the text 'Overall', ensure it's left-aligned
                try {
                  const cellVal = exportData && exportData[rowIndex?.index] && exportData[rowIndex?.index][colIndex];
                  if (String(cellVal || '').trim() === 'Overall') {
                    worksheet[cellAddress].s = { ...sectionStyle, alignment: { horizontal: 'left', vertical: 'center' } };
                  } else {
                    worksheet[cellAddress].s = sectionStyle;
                  }
                } catch (e) {
                  worksheet[cellAddress].s = sectionStyle;
                }
                break;
              case 'content':
                // Ensure content cells use content style without fill
                const contentValueStyle = { ...contentStyle };
                if (contentValueStyle && contentValueStyle.fill) delete contentValueStyle.fill;
                if (colIndex >= 1 && colIndex <= 6) {
                  worksheet[cellAddress].s = { ...contentValueStyle, ...localContentCenter };
                } else {
                  worksheet[cellAddress].s = { ...contentValueStyle, ...localContentStyle };
                }
                break;
              case 'daypart':
                // Apply daypart style only to first column (daypart name)
                if (colIndex === 0) {
                  worksheet[cellAddress].s = { ...daypartStyle, alignment: { horizontal: 'left', vertical: 'center' } };
                } else {
                  const valueStyle = { ...contentStyle };
                  if (valueStyle && valueStyle.fill) delete valueStyle.fill;
                  worksheet[cellAddress].s = { ...valueStyle, alignment: { horizontal: 'left', vertical: 'center' } };
                }
                break;
              case 'dish':
                const cellnumber = XLSX.utils.encode_cell({ r: rowIndex?.index, c: 0 })
                // Apply dish style but ensure it's not bold
                const nonBoldDishStyle = { ...dishStyle };
                if (nonBoldDishStyle.font) nonBoldDishStyle.font = { ...nonBoldDishStyle.font, bold: false };
                else nonBoldDishStyle.font = { bold: false };
                worksheet[cellnumber].s = nonBoldDishStyle;
                // Ensure dish rows (Event) have their value columns centered like content rows and not bold
                const contentVal = { ...contentStyle };
                if (contentVal && contentVal.fill) delete contentVal.fill;
                const centeredValStyle = { ...contentVal, alignment: { horizontal: 'center', vertical: 'center' } };
                centeredValStyle.font = { ...(centeredValStyle.font || {}), bold: false };
                for (let col = 1; col <= Math.min(6, maxWidth - 1); col++) {
                  const addr = XLSX.utils.encode_cell({ r: rowIndex?.index, c: col });
                  if (!worksheet[addr]) worksheet[addr] = {};
                  worksheet[addr].s = centeredValStyle;
                }
                break;
              default:
                break;
            }
          }
        }))
        
        // Add border to title row
        const titleRowObj = rowIndexes?.find(r => r.style === 'title');       
        if (titleRowObj && titleRowObj.index !== undefined) {
          for (let c = 0; c < maxWidth; c++) {
            const addr = XLSX.utils.encode_cell({ r: titleRowObj.index, c });
            if (!worksheet[addr]) worksheet[addr] = { v: '' };
            if (!worksheet[addr].s) worksheet[addr].s = {};
            const existingStyle = { ...worksheet[addr].s };
            worksheet[addr].s = {
              ...existingStyle,
              border: {
                top: { style: 'thin', color: { rgb: '000000' } },
                bottom: { style: 'thin', color: { rgb: '000000' } },
                left: { style: 'thin', color: { rgb: '000000' } },
                right: { style: 'thin', color: { rgb: '000000' } }
              }
            };
          }
        }
        
        // Restore borders for all cells except the merged date row (row index 1)
        for (let rowIdx = 0; rowIdx < exportData.length; rowIdx++) {
          if (rowIdx === 1) continue; // skip date row which already has full borders
          // Skip empty rows (trailing blank rows added after dayparts)
          const isEmptyRow1 = !exportData[rowIdx] || exportData[rowIdx].length === 0 || exportData[rowIdx].every((cell: any) => cell === '' || cell === undefined || cell === null);
          if (isEmptyRow1) continue;
          for (let colIdx = 0; colIdx < maxWidth; colIdx++) {
            const cellAddress = XLSX.utils.encode_cell({ r: rowIdx, c: colIdx });

            if (!worksheet[cellAddress]) {
              worksheet[cellAddress] = { v: "" };
            }

            if (!worksheet[cellAddress].s) {
              worksheet[cellAddress].s = {};
            }

            // Preserve existing alignment if it exists
            const existingAlignment = worksheet[cellAddress].s?.alignment;

            worksheet[cellAddress].s.border = {
              top: { style: "thin", color: { rgb: "000000" } },
              bottom: { style: "thin", color: { rgb: "000000" } },
              left: { style: "thin", color: { rgb: "000000" } },
              right: { style: "thin", color: { rgb: "000000" } }
            };

            if (existingAlignment) {
              worksheet[cellAddress].s.alignment = existingAlignment;
            }
          }
        }
        
        // Extend sheet ref to 300 rows x 50 cols so empty cells beyond data are written
        const totalRows1 = Math.max(exportData.length, 300);
        const totalCols1 = Math.max(maxWidth, 50);
        worksheet['!ref'] = XLSX.utils.encode_range({ s: { r: 0, c: 0 }, e: { r: totalRows1 - 1, c: totalCols1 - 1 } });
        // Apply white fill to ALL cells (data + empty) across full sheet to suppress Excel gridlines
        for (let rowIdx = 0; rowIdx < totalRows1; rowIdx++) {
          for (let colIdx = 0; colIdx < totalCols1; colIdx++) {
            const cellAddress = XLSX.utils.encode_cell({ r: rowIdx, c: colIdx });
            if (!worksheet[cellAddress]) worksheet[cellAddress] = { v: '', s: {} };
            if (!worksheet[cellAddress].s) worksheet[cellAddress].s = {};
            if (!worksheet[cellAddress].s.fill) {
              worksheet[cellAddress].s.fill = { patternType: 'solid', fgColor: { rgb: 'FFFFFF' } };
            }
          }
        }
        
        XLSX.utils.book_append_sheet(workbook, worksheet, section?.kitchensectionname?.replace(/[^a-zA-Z0-9 _]/g, ' ').substring(0, 30).trim());
      })
      // Export the workbook to an Excel file
      XLSX.writeFile(workbook, `Production_Plan_${params ? format(new Date(params.menudate), 'dd MMM yyyy') : 'No Date'}.xlsx`);
      toast("File downloaded successfully!", { type: "success" });
    } else {
      toast("No data available to export", { type: "info" });
    }
  }

  const handleDispatchReport = async (type: string) => {
    try {
      const payload = {
        userid: userId,
        ...params,
        ...(userIsItem === true ? { isitemwise: true } : {}),

      }
      const result = await dispatch(fetchProductionPlanReport(payload));
      console.log("Dispatch report result:", result);
      let dispatchReportData = result?.payload;
      if (dispatchReportData?.kitchensectionlist?.length > 0) {
        // Create a new workbook and worksheet
        
        const workbook = XLSX.utils.book_new();
        if(dispatchReportData?.mealcountdata?.sitelist?.length > 0 && type === 'dispatch'){
          const mealCountData = dispatchReportData?.mealcountdata;
          
          // Get all sites and their cafes to calculate total columns
          const allSites = mealCountData?.sitelist || [];
          const totalCafes = allSites.reduce((sum: number, site: any) => sum + (site.cafelist?.length || 0), 0);
          
          // maxWidth = empty col + Total col + all cafe columns
          let maxWidth = 2 + totalCafes;
          let startingIndex = 0;
          let rowIndexes: any[] = [{
            index: startingIndex,
            style: 'title'
          }];
          let mergedCells: any[] = [];
          
          const header = [[`Production Plan - ${userData?.cpusitename || sites[0].sitename}-${userData?.cpusitecode=="0" || userData?.cpusitecode=="" ?  sites[0].sitecode : userData?.cpusitecode }`, ...Array(maxWidth - 1).fill('')]]
          const dateHeader = [[params ? `Date: ${format(new Date(params.menudate), 'dd MMM yyyy')}` : 'No Date']]
          let exportData: any = [
            ...header,
            ...dateHeader,
            ...[['']]
          ];
          startingIndex += 3;

          // Build site header row: Empty | Empty | sitename1 (spans cafes) | sitename2 (spans cafes) ...
          const siteHeaderRow: any[] = ["", ""];
          let colIndex = 2;
          allSites.forEach((site: any) => {
            const cafeCount = site.cafelist?.length || 0;
            siteHeaderRow.push(site.sitename);
            // Add empty cells for remaining cafes under this site
            for (let i = 1; i < cafeCount; i++) {
              siteHeaderRow.push("");
            }
            // Add merge for site header spanning its cafes
            if (cafeCount > 1) {
              mergedCells.push({ s: { r: startingIndex, c: colIndex }, e: { r: startingIndex, c: colIndex + cafeCount - 1 } });
            }
            colIndex += cafeCount;
          });
          exportData.push(siteHeaderRow);
          rowIndexes.push({ index: startingIndex, style: 'header' });
          startingIndex++;

          // Build cafe header row: Empty | Total | cafename1 | cafename2 | ... for each site
          const cafeHeaderRow: any[] = ["", "Total"];
          allSites.forEach((site: any) => {
            site.cafelist?.forEach((cafe: any) => {
              cafeHeaderRow.push(cafe.cafename);
            });
          });
          exportData.push(cafeHeaderRow);
          rowIndexes.push({ index: startingIndex, style: 'header' });
          startingIndex++;

          // Get dayparts and mealtypes from the first site's first cafe
          const firstCafe = allSites[0]?.cafelist?.[0];
          const daypartList = firstCafe?.daypartlist || [];

          // For each daypart, add daypart row and meal type rows
          daypartList.forEach((daypart: any) => {
            // Add daypart header row
            const daypartRow = [daypart.daypartname, ...Array(maxWidth - 1).fill("")];
            exportData.push(daypartRow);
            rowIndexes.push({ index: startingIndex, style: 'daypart' });
            startingIndex++;

            // Get meal types from this daypart
            const mealTypeList = daypart.mealtypelist || [];

            mealTypeList.forEach((mealType: any) => {
              const mealTypeRow: any[] = [`  ${mealType.mealcounttypename}`];
              let totalCount = 0;

              // Collect counts for each cafe across all sites
              const cafeCounts: number[] = [];
              allSites.forEach((site: any) => {
                site.cafelist?.forEach((cafe: any) => {
                  // Find matching daypart and mealtype in this cafe
                  const matchingDaypart = cafe.daypartlist?.find((dp: any) => dp.daypartcode === daypart.daypartcode);
                  const matchingMealType = matchingDaypart?.mealtypelist?.find((mt: any) => mt.mealcounttypecode === mealType.mealcounttypecode);
                  const count = matchingMealType?.mealcount || 0;
                  cafeCounts.push(count);
                  totalCount += count;
                });
              });

              // Add Total column and cafe counts
              mealTypeRow.push(totalCount, ...cafeCounts);
              exportData.push(mealTypeRow);
              startingIndex++;
            });
          });

          // Add empty row at the end
          exportData.push([""]);
          startingIndex++;
          
          const worksheet = XLSX.utils.aoa_to_sheet(exportData);
          worksheet['!cols'] = calculateColumnWidths(exportData);
          
          // Apply merged cells for site headers
          worksheet['!merges'] = mergedCells;
          
          // Apply borders to date header cell (row index 1, column 0)
          const dateHeaderCell = XLSX.utils.encode_cell({ r: 1, c: 0 });
          if (!worksheet[dateHeaderCell]) {
            worksheet[dateHeaderCell] = { v: "" };
          }
          if (!worksheet[dateHeaderCell].s) {
            worksheet[dateHeaderCell].s = {};
          }
          worksheet[dateHeaderCell].s.border = {
            top: { style: "thin", color: { rgb: "000000" } },
            bottom: { style: "thin", color: { rgb: "000000" } },
            left: { style: "thin", color: { rgb: "000000" } },
            right: { style: "thin", color: { rgb: "000000" } }
          };
          
          rowIndexes?.forEach(((rowIndex, i) => {
            // Apply the header style to all header cells
            for (let colIndex = 0; colIndex < maxWidth; colIndex++) {
              const cellAddress = XLSX.utils.encode_cell({ r: rowIndex?.index, c: colIndex });
              if (!worksheet[cellAddress]) {
                worksheet[cellAddress] = {};
              }

              switch (rowIndex?.style) {
                case 'title':
                  worksheet[cellAddress].s = titleStyle;
                  break;
                case 'header':
                  worksheet[cellAddress].s = headerStyle;
                  break;
                case 'section':
                  worksheet[cellAddress].s = { ...sectionStyle, alignment: { horizontal: 'left', vertical: 'center' } };
                  break;
                case 'content': {
                  const contentVal = { ...contentStyle };
                  if (contentVal && contentVal.fill) delete contentVal.fill;
                  worksheet[cellAddress].s = { ...contentVal, alignment: { horizontal: 'left', vertical: 'center' } };
                  break;
                }
                case 'daypart': {
                  const existingCell = worksheet[cellAddress]?.s || {};
                  worksheet[cellAddress].s = {
                    ...daypartStyle,
                    ...existingCell,
                    font: { ...(daypartStyle.font || {}), ...(existingCell.font || {}), bold: true },
                    alignment: { horizontal: 'left', vertical: 'center' }
                  };
                  break;
                }
                case 'dish': {
                  const cellnumber = XLSX.utils.encode_cell({ r: rowIndex?.index, c: 0 });
                  worksheet[cellnumber].s = dishStyle;
                  break;
                }
                default:
                  break;
              }
            }
          }))
          
          // Add border to title row
          const titleRowObjMeal = rowIndexes?.find(r => r.style === 'title');
          if (titleRowObjMeal && titleRowObjMeal.index !== undefined) {
            for (let c = 0; c < maxWidth; c++) {
              const addr = XLSX.utils.encode_cell({ r: titleRowObjMeal.index, c });
              if (!worksheet[addr]) worksheet[addr] = { v: '' };
              if (!worksheet[addr].s) worksheet[addr].s = {};
              const existingStyle = { ...worksheet[addr].s };
              worksheet[addr].s = {
                ...existingStyle,
                border: {
                  top: { style: 'thin', color: { rgb: '000000' } },
                  bottom: { style: 'thin', color: { rgb: '000000' } },
                  left: { style: 'thin', color: { rgb: '000000' } },
                  right: { style: 'thin', color: { rgb: '000000' } }
                }
              };
            }
          }
          
          // Extend sheet ref to 300 rows x 50 cols so empty cells beyond data are written
          const totalRows2 = Math.max(exportData.length, 300);
          const totalCols2 = Math.max(maxWidth, 50);
          worksheet['!ref'] = XLSX.utils.encode_range({ s: { r: 0, c: 0 }, e: { r: totalRows2 - 1, c: totalCols2 - 1 } });
          // Apply white fill to ALL cells (data + empty) across full sheet to suppress Excel gridlines
          for (let rowIdx = 0; rowIdx < totalRows2; rowIdx++) {
            for (let colIdx = 0; colIdx < totalCols2; colIdx++) {
              const cellAddress = XLSX.utils.encode_cell({ r: rowIdx, c: colIdx });
              if (!worksheet[cellAddress]) worksheet[cellAddress] = { v: '', s: {} };
              if (!worksheet[cellAddress].s) worksheet[cellAddress].s = {};
              if (!worksheet[cellAddress].s.fill) {
                worksheet[cellAddress].s.fill = { patternType: 'solid', fgColor: { rgb: 'FFFFFF' } };
              }
            }
          }
          
          XLSX.utils.book_append_sheet(workbook, worksheet, 'Meal Count');
        }

        dispatchReportData?.kitchensectionlist?.map((section: any) => {
          let maxWidth = 0
          if (type === 'cafewise') {
            maxWidth = section?.sitelist?.flatMap(site => [site.sitename, ...Array(2 * (site?.cafelist?.length) - 1).fill('')])?.length + 8;
          } else {
            maxWidth = section?.sitelist?.flatMap(site => [site.sitename, ...Array(site?.cafelist?.length - 1).fill('')])?.length + 8;
          }
          let mergedCellIndex = 3
          let mergedCellRows = []
          let startingIndex = 0;
          let rowIndexes = [{
            index: startingIndex,
            style: 'title'
          }]
          const header = [[`Production Plan - ${userData?.cpusitename || sites[0].sitename}-${userData?.cpusitecode=="0" || userData?.cpusitecode=="" ?  sites[0].sitecode : userData?.cpusitecode }`, ...Array(maxWidth - 1).fill('')]]
          const dateHeader = [[params ? `Date: ${format(new Date(params.menudate), 'dd MMM yyyy')}` : 'No Date']]
          let exportData: any = [
            ...header,
            ...dateHeader,
            ...[['']]
          ];
          startingIndex += 3;
          
          //added for meal count section
          let mealTimeRowIndexes: number[] = [];
          if(section?.daypartlist && section?.daypartlist?.length > 0){
            const dayPartHeader = section.kitchensectionname=='Overall'
              && dispatchReportData?.mealcountdata?.sitelist?.length > 0 && type === 'dispatch' ? 
                [['Meal Time' , 'Quantity (In KG)','Meal Count',...Array(maxWidth - 1).fill('')]]
                : [['Meal Time' , 'Quantity (In KG)',...Array(maxWidth - 1).fill('')]]
            const dayPartData = []
            
            // Track the meal time header row
            mealTimeRowIndexes.push(startingIndex);
            
            section?.daypartlist?.forEach((daypart:any) => {
                const dayPartSingleRow = []
                dayPartSingleRow.push( [daypart.daypartname])
                dayPartSingleRow.push( [daypart.quantity ? daypart.quantity.toFixed(2) : ''])

                if(section.kitchensectionname=='Overall' && dispatchReportData?.mealcountdata?.sitelist?.length > 0 && type === 'dispatch' ){
                  dayPartSingleRow.push( [daypart.mealcount ? daypart.mealcount.toFixed(2) : ''])
                }

                dayPartData.push( dayPartSingleRow)
              }
            )
            
            // Track each meal time data row
            for(let i = 0; i < section?.daypartlist?.length; i++) {
              mealTimeRowIndexes.push(startingIndex + 1 + i);
            }

            if(section.kitchensectionname=='Overall' && dispatchReportData?.mealcountdata?.sitelist?.length > 0 && type === 'dispatch'){
                dayPartData.push( ['Total' , section?.daypartlist?.reduce((acc:any, curr:any) => acc + curr.quantity, 0).toFixed(2), section?.daypartlist?.reduce((acc:any, curr:any) => acc + curr.mealcount, 0).toFixed(2)])
            }else{
              dayPartData.push( ['Total' , section?.daypartlist?.reduce((acc:any, curr:any) => acc + curr.quantity, 0).toFixed(2)])
            }
            
            // Track the total row
            mealTimeRowIndexes.push(startingIndex + section?.daypartlist?.length + 1);
            
             exportData = [
              ...exportData,
              ...dayPartHeader,
              ...dayPartData,
              ...[['']]
            ]

            startingIndex +=  3 + section?.daypartlist?.length; 
            mergedCellIndex += 3 + section?.daypartlist?.length;
          }


          const sectionHeader = [[`${section?.kitchensectionname}`, ...Array(maxWidth - 1).fill('')]]
          rowIndexes.push({
            index: startingIndex,
            style: 'section'
          })
          // Track where table with column headers starts (after section header)
          const tableStartRow = startingIndex + 1;
          
          const { excelData: combinedData, siteMerges } = getReportData(section, mergedCellIndex, mergedCellRows, type, rowIndexes, startingIndex)
          exportData = [
            ...exportData,
            ...sectionHeader,
            ...combinedData,
            ...[['']]
          ]

          const worksheet = XLSX.utils.aoa_to_sheet(exportData);
          worksheet['!cols'] = calculateColumnWidths(exportData);
          
          // Apply site header merges and section header merge
          const allMerges = [];
          // Merge title row across all columns
          allMerges.push({ s: { r: 0, c: 0 }, e: { r: 0, c: maxWidth - 1 } });
          if (siteMerges && siteMerges.length > 0) {
            allMerges.push(...siteMerges);
          }
          // Merge section header (Overall or other section name) across all columns
          allMerges.push({ s: { r: startingIndex, c: 0 }, e: { r: startingIndex, c: maxWidth - 1 } });
          worksheet['!merges'] = allMerges;
          
          // Apply borders to date header cell (row index 1, column 0)
          const dateHeaderCell = XLSX.utils.encode_cell({ r: 1, c: 0 });
          if (!worksheet[dateHeaderCell]) {
            worksheet[dateHeaderCell] = { v: "" };
          }
          if (!worksheet[dateHeaderCell].s) {
            worksheet[dateHeaderCell].s = {};
          }
          worksheet[dateHeaderCell].s.border = {
            top: { style: "thin", color: { rgb: "000000" } },
            bottom: { style: "thin", color: { rgb: "000000" } },
            left: { style: "thin", color: { rgb: "000000" } },
            right: { style: "thin", color: { rgb: "000000" } }
          };         
          // Apply styling only to "Meal Time" and "Quantity (In KG)" cells in the heading row
          if (mealTimeRowIndexes.length > 0) {
            const headerRowIdx = mealTimeRowIndexes[0]; // First index is the header row
            const totalRowIdx = mealTimeRowIndexes[mealTimeRowIndexes.length - 1]; // Last index is the Total row
            
            for (let colIndex = 0; colIndex < maxWidth; colIndex++) {
              const cellAddress = XLSX.utils.encode_cell({ r: headerRowIdx, c: colIndex });
              const cellValue = worksheet[cellAddress]?.v;
              
              if (!worksheet[cellAddress]) {
                worksheet[cellAddress] = {};
              }
              
              // Apply background color only to "Meal Time", "Quantity (In KG)", and "Meal Count" cells
              if (cellValue === 'Meal Time' || cellValue === 'Quantity (In KG)' || cellValue === 'Meal Count') {
                worksheet[cellAddress].s = { ...sectionStyle, alignment: { horizontal: 'left', vertical: 'center' } };
              }
            }
            
            // Apply styling to Total row
            for (let colIdx = 0; colIdx < 3; colIdx++) {
              const cellAddress = XLSX.utils.encode_cell({ r: totalRowIdx, c: colIdx });
              const cellValue = worksheet[cellAddress]?.v;              
              const hasValue = cellValue !== undefined && cellValue !== null && cellValue !== '';
              
              if (hasValue) {
                // Convert string values to numbers for numeric columns
                if (colIdx > 0) {
                  const num = typeof cellValue === 'string' ? parseFloat(cellValue) : cellValue;
                  if (!isNaN(num)) {
                    worksheet[cellAddress].v = num;
                  }
                }
                
                if (!worksheet[cellAddress].s) {
                  worksheet[cellAddress].s = {};
                }
                
                // Apply bold, background color, and borders to Total row
                worksheet[cellAddress].s = {
                  ...sectionStyle,
                  alignment: colIdx === 0 ? { horizontal: 'left', vertical: 'center' } : { horizontal: 'center', vertical: 'center' },
                  border: {
                    top: { style: "thin", color: { rgb: "000000" } },
                    bottom: { style: "thin", color: { rgb: "000000" } },
                    left: { style: "thin", color: { rgb: "000000" } },
                    right: { style: "thin", color: { rgb: "000000" } }
                  },
                  ...(colIdx > 0 ? { numFmt: '0.00' } : {})
                };
              }
            }
            
            // Apply borders to cells with values in meal time section (excluding Total row)
            mealTimeRowIndexes.forEach((rowIdx) => {
              if (rowIdx === totalRowIdx) return; // Skip Total row as it's already styled above
              
              for (let colIdx = 0; colIdx < 3; colIdx++) { // Only first 3 columns for meal time section
                const cellAddress = XLSX.utils.encode_cell({ r: rowIdx, c: colIdx });
                const cellValue = worksheet[cellAddress]?.v;
                const hasValue = cellValue !== undefined && cellValue !== null && cellValue !== '';
                
                if (hasValue) {
                  // Convert string values to numbers for numeric columns
                  if (colIdx === 1 || colIdx === 2) {
                    const num = typeof cellValue === 'string' ? parseFloat(cellValue) : cellValue;
                    if (!isNaN(num)) {
                      worksheet[cellAddress].v = num;
                    }
                  }
                  
                  if (!worksheet[cellAddress].s) {
                    worksheet[cellAddress].s = {};
                  }
                  
                  // Add borders first
                  worksheet[cellAddress].s.border = {
                    top: { style: "thin", color: { rgb: "000000" } },
                    bottom: { style: "thin", color: { rgb: "000000" } },
                    left: { style: "thin", color: { rgb: "000000" } },
                    right: { style: "thin", color: { rgb: "000000" } }
                  };
                  
                  // Add alignment after borders to ensure it's not overwritten
                  if (colIdx === 1 || colIdx === 2) {
                    worksheet[cellAddress].s.alignment = { horizontal: 'center', vertical: 'center' };
                    // Add 2-decimal formatting for numeric columns
                    worksheet[cellAddress].s.numFmt = '0.00';
                  } else {
                    // Left align Meal Time column (colIdx 0)
                    worksheet[cellAddress].s.alignment = { horizontal: 'left', vertical: 'center' };
                  }
                }
              }
            });
          }
          
          // Apply row styles FIRST before borders
          rowIndexes?.forEach(((rowIndex, i) => {
            // Apply the header style to all header cells
            for (let colIndex = 0; colIndex < maxWidth; colIndex++) {
              const cellAddress = XLSX.utils.encode_cell({ r: rowIndex?.index, c: colIndex });
              if (!worksheet[cellAddress]) {
                worksheet[cellAddress] = {};
              }

              switch (rowIndex?.style) {
                case 'title':
                  worksheet[cellAddress].s = titleStyle;
                  break;
                case 'header':
                  if (colIndex >= 1 && colIndex <= maxWidth - 2) {
                    // Center align header cells for all columns except Dish and Remarks
                    worksheet[cellAddress].s = { ...headerStyle, alignment: { horizontal: 'center', vertical: 'center' } };
                  } else {
                    worksheet[cellAddress].s = headerStyle;
                  }
                  break;
                case 'section':
                  worksheet[cellAddress].s = { ...sectionStyle, alignment: { horizontal: 'left', vertical: 'center' } };
                  break;
                case 'content':
                  worksheet[cellAddress].s = { ...contentStyle, alignment: { horizontal: 'left', vertical: 'center' } };
                  break;
                case 'daypart':
                  if (colIndex === 0) {
                    worksheet[cellAddress].s = { ...daypartStyle, alignment: { horizontal: 'left', vertical: 'center' } };
                  } else {
                    const valueStyle = { ...contentStyle };
                    if (valueStyle && valueStyle.fill) delete valueStyle.fill;
                    worksheet[cellAddress].s = { ...valueStyle, alignment: { horizontal: 'left', vertical: 'center' } };
                  }
                  break;
                case 'dish':
                  const cellnumber = XLSX.utils.encode_cell({ r: rowIndex?.index, c: 0 })
                  worksheet[cellnumber].s = dishStyle;
                  break;
                default:
                  break;
              }
            }
          }))
          
          // Add border to title row
          const titleRowObjSection = rowIndexes?.find(r => r.style === 'title');
          
          if (titleRowObjSection && titleRowObjSection.index !== undefined) {
            for (let c = 0; c < maxWidth; c++) {
              const addr = XLSX.utils.encode_cell({ r: titleRowObjSection.index, c });
              if (!worksheet[addr]) worksheet[addr] = { v: '' };
              if (!worksheet[addr].s) worksheet[addr].s = {};
              const existingStyle = { ...worksheet[addr].s };
              worksheet[addr].s = {
                ...existingStyle,
                border: {
                  top: { style: 'thin', color: { rgb: '000000' } },
                  bottom: { style: 'thin', color: { rgb: '000000' } },
                  left: { style: 'thin', color: { rgb: '000000' } },
                  right: { style: 'thin', color: { rgb: '000000' } }
                }
              };
            }
          }
          
          // Apply borders AFTER styling to preserve alignment
          for (let rowIdx = tableStartRow; rowIdx < exportData.length; rowIdx++) {
            // Skip empty rows (trailing blank rows added after dayparts)
            const isEmptyRow3 = !exportData[rowIdx] || exportData[rowIdx].length === 0 || exportData[rowIdx].every((cell: any) => cell === '' || cell === undefined || cell === null);
            if (isEmptyRow3) continue;
            for (let colIdx = 0; colIdx < maxWidth; colIdx++) {
              const cellAddress = XLSX.utils.encode_cell({ r: rowIdx, c: colIdx });
              
              // Create cell if it doesn't exist
              if (!worksheet[cellAddress]) {
                worksheet[cellAddress] = { v: "" };
              }
              
              // Add full border to all cells in the table
              if (!worksheet[cellAddress].s) {
                worksheet[cellAddress].s = {};
              }
              
              // Preserve existing alignment if it exists (before applying border)
              const existingAlignment = worksheet[cellAddress].s?.alignment;
              
              worksheet[cellAddress].s.border = {
                top: { style: "thin", color: { rgb: "000000" } },
                bottom: { style: "thin", color: { rgb: "000000" } },
                left: { style: "thin", color: { rgb: "000000" } },
                right: { style: "thin", color: { rgb: "000000" } }
              };
              
              // Restore or apply alignment after border
              if (existingAlignment) {
                // Preserve any existing alignment (from daypart, section, etc.)
                worksheet[cellAddress].s.alignment = existingAlignment;
              } else if (colIdx >= 1 && colIdx <= maxWidth - 2) {
                // Apply center alignment to data columns that don't have alignment yet
                worksheet[cellAddress].s.alignment = { horizontal: 'center', vertical: 'center' };
              }
            }
          }
          
          // Extend sheet ref to 300 rows x 50 cols so empty cells beyond data are written
          const totalRows3 = Math.max(exportData.length, 300);
          const totalCols3 = Math.max(maxWidth, 50);
          worksheet['!ref'] = XLSX.utils.encode_range({ s: { r: 0, c: 0 }, e: { r: totalRows3 - 1, c: totalCols3 - 1 } });
          // Apply white fill to ALL cells (data + empty) across full sheet to suppress Excel gridlines
          for (let rowIdx = 0; rowIdx < totalRows3; rowIdx++) {
            for (let colIdx = 0; colIdx < totalCols3; colIdx++) {
              const cellAddress = XLSX.utils.encode_cell({ r: rowIdx, c: colIdx });
              if (!worksheet[cellAddress]) worksheet[cellAddress] = { v: '', s: {} };
              if (!worksheet[cellAddress].s) worksheet[cellAddress].s = {};
              if (!worksheet[cellAddress].s.fill) {
                worksheet[cellAddress].s.fill = { patternType: 'solid', fgColor: { rgb: 'FFFFFF' } };
              }
            }
          }
          
          XLSX.utils.book_append_sheet(workbook, worksheet, section?.kitchensectionname?.replace(/[^a-zA-Z0-9 _]/g, ' ').substring(0, 30).trim());
        })
        // Export the workbook to an Excel file
        XLSX.writeFile(workbook, `${type === 'cafewise' ? 'Cafewise_Production_Plan' : 'Production_Dispatch_Report'}${params ? format(new Date(params.menudate), 'dd MMM yyyy') : 'No Date'}.xlsx`);
        toast("File downloaded successfully!", { type: "success" });
      } else {
        toast("No data available to export", { type: "info" });
      }
    } catch (error) {
      console.error("Something went wrong:", error);
      toast("Something went wrong", { type: "error" });
    }
  }


  return (
    <div className="white-box mb-12">
      <div className="flex justify-content-between align-items-center title-button-wrapper mb-8">
        <div className="flex align-items-center">
          <Paper className={`search-input mr-12 ${styles.search}`}>
            <InputBase placeholder="Search Dishes Name" disabled={disableCTA} value={searchTerm} onChange={(e) => setSearchTerm(e?.target?.value)} />
            <IconButton type="button" aria-label="search">
              <IconSearch />
            </IconButton>
          </Paper>
        </div>
        <div className="button-wrap flex align-items-center">
          <Button disabled={disableCTA} className="link-btn" disableRipple onClick={handleExpandAll}>
            Expand All
          </Button>
          <span className='divider'></span>
          <Button disabled={disableCTA} className='link-btn' disableRipple onClick={handleCollapseAll}>
            Collapse All
          </Button>
          {showUpdatePlan && <>
            <span className="divider"></span>
            <Button disabled={disableCTA} onClick={() => navigate("/updateproductionplan")} className="cmenu-btn" disableRipple>
              <ReportIcon /> Update Production Plan
            </Button>
          </>}
          <span className="divider"></span>
          <Button disabled={disableCTA} onClick={() => handleExport()} className="cmenu-btn" disableRipple>
            <IconExport /> Export
          </Button>
          <span className="divider"></span>
          <Button disabled={disableCTA} onClick={() => handleDispatchReport('cafewise')} className="cmenu-btn" disableRipple>
            <IconExport /> Export Café Wise
          </Button>
          <span className="divider"></span>
          <Button disabled={disableCTA} onClick={() => handleDispatchReport('dispatch')} className="cmenu-btn" disableRipple>
            <IconExport /> Dispatch Report 
          </Button>
          <div className='toggle-button-wrap'>
            <Button className='primary-btn btn-right ml-16' disabled={disableCTA} onClick={handleMenuOpen} disableRipple>
              Kitchen Indent
            </Button>
            <Menu
              anchorEl={anchorEl}
              open={Boolean(anchorEl)}
              onClose={handleMenuClose}
              className='menu-dropdown-list'
            >
              {!!dynamicMealTimeOptions?.length && dynamicMealTimeOptions?.map((option: any, index: number) => (
                <MenuItem key={index} className='list'>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={selectedOptions?.includes(option?.value)}
                        onChange={handleOptionChange}
                        name={option?.value}
                      />
                    }
                    label={option?.label}
                  />
                </MenuItem>
              ))}

              <MenuItem>
                <div className='submit-button-wrapper'>
                  <Button fullWidth variant="contained" disabled={!selectedOptions?.length} onClick={handleSubmit} className='primary-btn'>
                    Submit
                  </Button>
                </div>
              </MenuItem>
            </Menu>
          </div>
        </div>
      </div>

      <div className={`flex justify-content-between ${styles.tabbingDataWrap}`}>
        <Tabs
          value={value}
          onChange={handleChange}
          aria-label="Tabs"
          className="tabs-wrapper"
        >
          {productionData?.length > 0 && productionData?.map((kitchenSection: any, index: number) => {
            return <Tab key={index} label={kitchenSection?.kitchensectionname} sx={{ color: kitchenSection?.kitchensectionname?.toLowerCase()?.includes('event') && "#1AD55B !important" || kitchenSection?.kitchensectionname?.toLowerCase()?.includes('bakery') && "#F9B959 !important" }} id={`simple-tabpanel-${index}`} aria-labelledby={`simple-tab-${index}`} disableRipple />
          })}
        </Tabs>
      </div>
      <div className="inner-contant kitchen-dashboard">
        {productionData?.length > 0 && productionData?.map((kitchenSection: any, index: number) => {
          return (<CustomTabPanel key={index} value={value} index={index}>
            <ListData
              tabValue={value}
              openIndices={openIndices}
              setOpenIndices={setOpenIndices}
              handleToggle={handleToggle}
              dayPartDishList={kitchenSection?.daypartdishlist}
              kitchenSectionCode={kitchenSection?.kitchensectioncode}
              searchTerm={searchTerm}
            />
          </CustomTabPanel>
          )
        })}
      </div>
      {loading && <Loader />}
    </div>
  );
};

export default ProductionPlanDetails;